module.exports = __webpack_public_path__ + "static/media/cm.c23dc8bc.svg";